import { PermissionList, ROLE, RoleList, RoleType } from '../../crm/helpers/Permissions';
import AdminPolicyService from '../../crm/services/AdminPolicyService';
import Auth from '../../crm/services/Auth';

import Admin from './Admin';

export default class LoggedAdmin extends Admin {
    /**
     * Determine if the logged in admin has (one of) the given role(s).
     */
    hasRole(...roles: RoleList): boolean {
        return Auth.userHasAnyRole(this, roles);
    }

    /**
     * Determine if the logged in admin has (one of) the given permission(s).
     */
    hasPermission(...permissions: PermissionList): boolean {
        return Auth.userHasAnyPermission(this, permissions);
    }

    /**
     * Determine if the logged in admin has any of the specified roles or permissions.
     */
    hasAccess(roles: RoleList = [], permissions: PermissionList = []): boolean {
        return Auth.userHasAnyRoleOrPermission(this, roles, permissions);
    }

    isSuperAdmin(): boolean {
        return Auth.userHasRole(this, ROLE.SUPER_ADMIN);
    }

    hasSuperRole(): boolean {
        return AdminPolicyService.hasSuperRole(this);
    }

    hasMainRole(): boolean {
        return AdminPolicyService.hasMainRole(this);
    }

    canView(admin: Admin): boolean {
        return admin?.roles && AdminPolicyService.adminCanView(this, admin);
    }

    canManage(role: RoleType): boolean {
        return role?.length && AdminPolicyService.adminCanManage(this, role);
    }

    canModify(admin: Admin): boolean {
        return admin?.roles && AdminPolicyService.adminCanModify(this, admin);
    }
}
